<template>
  <LayoutGradient :title="title" :icon="'fa-'+iconName" :hide-gradient="hideGradient">
    <template v-slot:headerRight>
      <slot name="headerRight">
        <router-link v-if="routeNew" id="btn-criar" class="btn btn-outline-info" :to="{ name: routeNew }">
          <i class="fas fa-plus"/> {{ textNew }}
        </router-link>
      </slot>
    </template>

    <div :class="{'mt-n10': !hideGradient}">
      <TableData
          :fields-filter="fieldsFilter"
          :initial="initialFields"
          :fields="fields"
          :disable-filter="disableFilter"

          :items="items"
          :loading="loading"
          :selectable="selectable"
          :paginator="paginator"
          :text-empty="textEmpty"
          :route-new="routeNew"
          :text-new="textNew"
          @list="evt => $emit('list', evt)"
          @select="evt => $emit('select', evt)"
          @sort-changed="evt => $emit('sort-changed', evt)"
      >
        <template v-for="slotName in Object.keys($scopedSlots)" v-slot:[slotName]="slotScope">
          <slot :name="slotName" v-bind="slotScope"/>
        </template>
      </TableData>
    </div>

    <template v-slot:LayoutGradientAppend>
      <slot name="LayoutGradientAppend"/>
    </template>

  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import TableData from "@/components/TableData";

export default {
  name: "TableGradient",
  components: {TableData, LayoutGradient},
  props: {
    title: {
      type: String
    },
    iconName: {
      type: String,
      default: 'table'
    },
    tableData: {
      type: Boolean,
      default: false
    },

    /* Props TableData */
    disableFilter: {
      type: Boolean,
      default: false
    },
    initialFields: {
      type: Array
    },
    fieldsFilter: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array
    },
    items: {
      type: Array
    },
    paginator: {
      type: Object
    },
    textEmpty: {
      type: String
    },
    loading: {
      type: Boolean
    },
    selectable: {
      type: Boolean
    },
    routeNew: {
      type: String
    },
    textNew: {
      type: String
    },
  },
  computed: {
    hideGradient() {
      // Every Cycle  check if has Item
      if (this.items.length > 0) {
        // If has Any item update state
        this.hasAnyItem = true
      }
      if (this.tableData && this.hasAnyItem) {
        return false
      }
      return this.items.length === 0
    }
  },
  data() {
    return {
      hasAnyItem: false
    }
  }
}
</script>
